import { render, staticRenderFns } from "./VariantFeatures.vue?vue&type=template&id=f30fb01c&scoped=true"
import script from "./VariantFeatures.vue?vue&type=script&lang=js"
export * from "./VariantFeatures.vue?vue&type=script&lang=js"
import style0 from "./VariantFeatures.vue?vue&type=style&index=0&id=f30fb01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30fb01c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmImg: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmImg.vue').default,TlmSection: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmSection.vue').default})
